import moment from "moment";

import { store } from "../store/configureStore";

import { setFormData, getFormData, getSystemSettings, setSeason, getSeason } from "../utils/SettingsRetriever";

export const setForm = (form, checkSeasonality = true, startDate = false) => {
    let seasonality = getSystemSettings().seasonality;
    // we check if seasonality is enabled in this destination
    if (seasonality && seasonality.enabled && checkSeasonality){
        let savedForm = getFormData();
        // if it's enabled, we're gonna see which form was the last one modified
        // so we get it's startDate to decide if we need to change the current season
        Object.keys(form).forEach((sectionForm) => {
            if (sectionForm){
                Object.keys(form[sectionForm]).forEach(formKey => {
                    if (savedForm[sectionForm] && savedForm[sectionForm][formKey]){
                        if (typeof form[sectionForm][formKey] === 'object' && form[sectionForm][formKey] !== null){
                            Object.keys(form[sectionForm][formKey]).forEach(formKeyValue => {
                                if (savedForm[sectionForm][formKey][formKeyValue] && savedForm[sectionForm][formKey][formKeyValue] !== form[sectionForm][formKey][formKeyValue]){
                                    if (sectionForm === "activities"){
                                        startDate = moment.utc(form[sectionForm].startDate)
                                    } else if (sectionForm === "liftTickets"){
                                        let stringDate = `${form[sectionForm].year}/${form[sectionForm].month}/01`;
                                        startDate = moment.utc(stringDate);
                                    } else {
                                        startDate = moment.utc(form[sectionForm].arrivalDate)
                                    }
                                }
                            })
                        } else {
                            if (savedForm[sectionForm][formKey] !== form[sectionForm][formKey]){
                                if (sectionForm === "activities"){
                                    startDate = moment.utc(form[sectionForm].startDate)
                                } else if (sectionForm === "liftTickets"){
                                    let stringDate = `${form[sectionForm].year}/${form[sectionForm].month}/01`;
                                    startDate = moment.utc(stringDate);
                                } else {
                                    startDate = moment.utc(form[sectionForm].arrivalDate)
                                }
                            }
                        }
                    }
                })
            }
        })
        let currentSeason = seasonality.list.find(season => season.isDefault === true);
        if (startDate){
            seasonality.list.forEach(season => {
                let seasonStart = moment.utc(season.start).startOf("day");
                let seasonEnd = moment.utc(season.end).startOf("day");
    
                if (startDate.isSameOrAfter(seasonStart) && startDate.isSameOrBefore(seasonEnd)){
                    currentSeason = season;
                }
                
            })
            if (getSeason() && currentSeason && getSeason().name !== currentSeason.name){
                // if the season has changed, we fire an event & save it on local storage
                // this event is read in TabGenerator.js
                setSeason(currentSeason);
                let event = new CustomEvent("changeSeason")
                document.dispatchEvent(event);
            }
        }
    }   
    setFormData(form);
    store.dispatch({ type: "SET_FORM_VALUE", value: form });
}